import { CALL_API } from '../middleware/api'

export const LICENSE_PRO_REQUEST_REQUEST  = 'LICENSE_PRO_REQUEST_REQUEST'
export const LICENSE_PRO_REQUEST_SUCCESS  = 'LICENSE_PRO_REQUEST_SUCCESS'
export const LICENSE_PRO_REQUEST_FAILURE  = 'LICENSE_PRO_REQUEST_FAILURE'
export const LICENSE_PRO_REQUEST_RESET    = 'LICENSE_PRO_REQUEST_RESET'

export function requestProUpgrade() {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'license/request-pro',
      authenticated: true,
      types: [
        LICENSE_PRO_REQUEST_REQUEST,
        LICENSE_PRO_REQUEST_SUCCESS,
        LICENSE_PRO_REQUEST_FAILURE,
      ],
    },
  }
}

export function resetProUpgrade() {
  return { type: LICENSE_PRO_REQUEST_RESET }
}
